// a minimal filtered column

import React from 'react'
import { Filters } from '../../legacy-design-system/filter'

export const FILTER_KEY = 'scores'
export const gradeHeaderRenderer = ({ renderContent, filters }) => {
  return (
    <Filters
      groupConfigs={filters.groupConfigs}
      selections={filters.selections}
      groupIDs={[filters.groupConfigs[FILTER_KEY].id]}
      onGroupToggle={filters.onGroupToggle}
      onOptionToggle={filters.onOptionToggle}
    >
      {({ isOpen, isTransitioning }) =>
        renderContent({
          isOpen,
          isFilterable: true,
          isFiltered: !!filters.selections[FILTER_KEY],
          isClickable: !isTransitioning,
          onClear: () =>
            filters.selections[FILTER_KEY].forEach((it) =>
              filters.onOptionToggle({
                groupID: FILTER_KEY,
                optionID: it
              })
            )
        })
      }
    </Filters>
  )
}
